import { render } from "./CardComentarios.vue?vue&type=template&id=e0be47b4&scoped=true"
import script from "./CardComentarios.vue?vue&type=script&lang=js"
export * from "./CardComentarios.vue?vue&type=script&lang=js"

import "./CardComentarios.vue?vue&type=style&index=0&id=e0be47b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0be47b4"]])

export default __exports__